import { DEVICES } from '@constants/global'
import styled from 'styled-components'

export const MapWrap = styled.div`
  height: 300px;
  margin-bottom: 56px;
  border-radius: 6px;
  overflow: hidden;

  @media ${DEVICES.mobile} {
    margin-bottom: 40px;
  }

  .fullscreen-ctrl-wrapper {
    right: 10px;
    bottom: 10px;
    z-index: 999;

    .mapboxgl-ctrl-group {
      background-color: transparent;

      button {
        width: 36px;
        height: 36px;
      }
    }
  }

  .nav-ctrl-wrapper {
    left: 10px;
    top: 10px;
  }

  .mapboxgl-ctrl {
    box-shadow: none !important;
  }

  .mapboxgl-ctrl-attrib,
  .mapboxgl-ctrl-zoom-in,
  .mapboxgl-ctrl-zoom-out {
    display: none !important;
  }

  .mapboxgl-ctrl button.mapboxgl-ctrl-fullscreen {
    .mapboxgl-ctrl-icon {
      background-image: url('/imgs/icons/fullscreen.svg');
    }
  }
`
